import { Outlet } from 'react-router-dom'

const Layout = () => {
  return (
    <main className='dashboard-wrapper'>
      <Outlet />
    </main>
  )
}

export default Layout
